import { Signal } from '@angular/core';

export type OtaOverlayMode = 'hidden' | 'splash' | 'updating' | 'restarting';

export abstract class OtaUpdateService {
  abstract readonly mode: Signal<OtaOverlayMode>;
  abstract readonly isFadingOut: Signal<boolean>;
  abstract readonly downloadPercent: Signal<number>;
  abstract init(): void;
}
